import { toDate } from 'date-fns'
import { IPeriodCache } from '../../lib/interfaces'
import React from 'react'
import { formatText } from '../../lib/dateFunctions'

export function renderDateRange(dateStart, dateEnd, dateFormat = 'dd-MM-yyyy') {
    return `${(dateStart && formatText(toDate(new Date(dateStart)), dateFormat)) || 'Open start'} / ${
        (dateEnd && formatText(toDate(new Date(dateEnd)), dateFormat)) || 'Open end'
    }`
}

export function renderDayCount(dayCount) {
    if (dayCount > 42) {
        return <span className="danger-text">{dayCount}</span>
    }
    return <span>{dayCount}</span>
}

export function isInTaxYear(llPeriod: IPeriodCache, taxYearVal: number) {
    if (llPeriod.start && !(new Date(llPeriod.start).getFullYear() <= taxYearVal)) return false
    if (llPeriod.end && !(new Date(llPeriod.end).getFullYear() >= taxYearVal)) return false
    return true
}
